import * as React from "react";

function DiscordWhite(props) {
  return (
    <svg viewBox="0 0 127.14 96.36" width="1em" height="1em" {...props}>
      <g data-name="\u56FE\u5C42 2">
        <g data-name="Discord Logos">
          <path
            d="M107.7 8.07A105.15 105.15 0 0081.47 0a72.06 72.06 0 00-3.36 6.83 97.68 97.68 0 00-29.11 0A72.37 72.37 0 0045.64 0a105.89 105.89 0 00-26.25 8.09C2.79 32.65-1.71 56.6.54 80.21a105.73 105.73 0 0032.17 16.15 77.7 77.7 0 006.89-11.11 68.42 68.42 0 01-10.85-5.18c.91-.66 1.8-1.34 2.66-2a75.57 75.57 0 0064.32 0c.87.71 1.76 1.39 2.66 2a68.68 68.68 0 01-10.87 5.19 77 77 0 006.89 11.1 105.25 105.25 0 0032.19-16.14c2.64-27.38-4.51-51.11-18.9-72.15zM42.45 65.69C36.18 65.69 31 60 31 53s5-12.74 11.43-12.74S54 46 53.89 53s-5.05 12.69-11.44 12.69zm42.24 0C78.41 65.69 73.25 60 73.25 53s5-12.74 11.44-12.74S96.23 46 96.12 53s-5.04 12.69-11.43 12.69z"
            fill="#fff"
            data-name="Discord Logo - Large - White"
          />
        </g>
      </g>
    </svg>
  );
}

const MemoDiscordWhite = React.memo(DiscordWhite);
export default MemoDiscordWhite;
